module.exports = __webpack_public_path__ + "img/twitter.d11d102e.svg";